import useDs from 'app/hook/common/useDs';
import useDidMount from 'app/hook/common/useDidMount';

export default function useTrackingDataStory(flag) {
	// Data Stroy : 페이지 이동시 실행 (wl6.js)
	const { getDsClickCode, setDsClickCodeReset } = useDs();

	useDidMount(() => {
		let checkJsLoadTime;
		if (flag) {
			try {
				let count = 0;
				checkJsLoadTime = setInterval(() => {
					if (typeof window.n_logging === 'function') {
						window.n_logging(getDsClickCode());
						setDsClickCodeReset();
						clearInterval(checkJsLoadTime);
					}
					count += 1;
					if (count > 50) {
						setDsClickCodeReset();
						clearInterval(checkJsLoadTime);
						console.log('dsLog: not working');
					}
				}, 150);
			} catch (err) {
				console.log(err);
			}
		}

		return () => {
			clearInterval(checkJsLoadTime);
		};
	});
}
